(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-collection-dynamic"]) return;
  try {
    
  (() => {
    const button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection"]) return;
  try {
    
  (() => {
    const button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });
  })();

  (() => {
    const seoCollections = document.querySelectorAll('[data-seo-collection]');
    if (!seoCollections.length) return;

    seoCollections.forEach((seoCollection) => {
      const description = seoCollection.querySelector('[data-seo-collection-description]');
      const toggle = seoCollection.querySelector('[data-seo-collection-toggle]');
      if (!description || !toggle) return;

      const labelMore = toggle.dataset.labelMore || 'Ver mais';
      const labelLess = toggle.dataset.labelLess || 'Ver menos';

      const updateToggleVisibility = () => {
        const wasExpanded = description.classList.contains('is-expanded');
        description.classList.remove('is-expanded');
        const hasOverflow = description.scrollHeight > description.clientHeight + 1;
        description.classList.toggle('is-expanded', wasExpanded);
        toggle.classList.toggle('is-hidden', !hasOverflow);
      };

      toggle.addEventListener('click', () => {
        const isExpanded = description.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        toggle.textContent = isExpanded ? labelLess : labelMore;
      });

      updateToggleVisibility();
      window.addEventListener('resize', updateToggleVisibility, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
